<section class="flex-container" *ngIf="showAll && !donutsDesignacionesInput">
    <div *ngFor="let expedicion of expedicionCero">
        <div *ngIf="expedicion !== undefined" class="donut" [ngClass]="animation ? 'all' : ''">
            <label>{{expedicion.label}}</label>
            <label [ngClass]="{'remove-label': !expedicion.subLabel}">{{expedicion.subLabel ? expedicion.subLabel : 'Sin subLabel'}}</label>
            <lib-dougnhut-chart [labelList]="expedicion.labelList" [dataList]="expedicion.dataList" [chartName]="'x'" [colors]="expedicion.colors"></lib-dougnhut-chart>
            <div class="buttons-section">
                <button id="info" [tooltip]="(expedicion.descripcion)"><i class="fa-solid fa-info"></i></button>
                <button class="grid" [ngClass]="{'disabled': !cargaCompleta}" (click)="showGrid(expedicion)" [tooltip]="('central-avisos.mostrarTabla' | translate)"><i class="fas fa-table"></i></button>
            </div>
        </div>
    </div>
    <div *ngFor="let expedicion of expedicionDesignados">
        <div *ngIf="expedicion !== undefined" class="donut" [ngClass]="animation ? 'all' : ''">
            <label>{{expedicion.label}}</label>
            <label [ngClass]="{'remove-label': !expedicion.subLabel}">{{expedicion.subLabel ? expedicion.subLabel : 'Sin subLabel'}}</label>
            <lib-dougnhut-chart [labelList]="expedicion.labelList" [dataList]="expedicion.dataList" [chartName]="'x'" [colors]="expedicion.colors"></lib-dougnhut-chart>
            <div class="buttons-section">
                <button id="info" [tooltip]="(expedicion.descripcion)"><i class="fa-solid fa-info"></i></button>
                <button class="grid" [ngClass]="{'disabled': !cargaCompleta}" (click)="showGrid(expedicion)" [tooltip]="('central-avisos.mostrarTabla' | translate)"><i class="fas fa-table"></i></button>
            </div>
        </div>
    </div>
    <div *ngFor="let designados of designadosAforo">
        <div *ngIf="designados !== undefined" class="donut" [ngClass]="animation ? 'all' : ''">
            <label>{{designados.label}}</label>
            <label [ngClass]="{'remove-label': !designados.subLabel}">{{designados.subLabel ? designados.subLabel : 'Sin subLabel'}}</label>
            <lib-dougnhut-chart [labelList]="designados.labelList" [dataList]="designados.dataList" [chartName]="'x'" [colors]="designados.colors"></lib-dougnhut-chart>
            <div class="buttons-section">
                <button id="info" [tooltip]="(designados.descripcion)"><i class="fa-solid fa-info"></i></button>
                <button class="grid" [ngClass]="{'disabled': !cargaCompleta}" (click)="showGrid(designados)" [tooltip]="('central-avisos.mostrarTabla' | translate)"><i class="fas fa-table"></i></button>
            </div>
        </div>
    </div>
    <div *ngFor="let designacion of designacionesDeshabilitadas">
        <div *ngIf="designacion !== undefined" class="donut" [ngClass]="animation ? 'all' : ''">
            <label>{{designacion.label}}</label>
            <label [ngClass]="{'remove-label': !designacion.subLabel}">{{designacion.subLabel ? designacion.subLabel : 'Sin subLabel'}}</label>
            <lib-dougnhut-chart [labelList]="designacion.labelList" [dataList]="designacion.dataList" [chartName]="'x'" [colors]="designacion.colors"></lib-dougnhut-chart>
            <div class="buttons-section">
                <button id="info" [tooltip]="(designacion.descripcion)"><i class="fa-solid fa-info"></i></button>
                <button class="grid" [ngClass]="{'disabled': !cargaCompleta}" (click)="showGrid(designacion)" [tooltip]="('central-avisos.mostrarTabla' | translate)"><i class="fas fa-table"></i></button>
            </div>
        </div>
    </div>
    <div *ngFor="let designacion of designacionesFinalizadas">
        <div *ngIf="designacion !== undefined" class="donut" [ngClass]="animation ? 'all' : ''">
            <label>{{designacion.label}}</label>
            <label [ngClass]="{'remove-label': !designacion.subLabel}">{{designacion.subLabel ? designacion.subLabel : 'Sin subLabel'}}</label>
            <lib-dougnhut-chart [labelList]="designacion.labelList" [dataList]="designacion.dataList" [chartName]="'x'" [colors]="designacion.colors"></lib-dougnhut-chart>
            <div class="buttons-section">
                <button id="info" [tooltip]="(designacion.descripcion)"><i class="fa-solid fa-info"></i></button>
                <button class="grid" [ngClass]="{'disabled': !cargaCompleta}" (click)="showGrid(designacion)" [tooltip]="('central-avisos.mostrarTabla' | translate)"><i class="fas fa-table"></i></button>
            </div>
        </div>
    </div>
</section>
<section class="flex-container" *ngIf="!showAll">
    <div *ngFor="let donut of donutsPorPrioridad">
        <div *ngIf="donut !== undefined" class="donut" [ngClass]="animation ? 'all' : ''">
            <label>{{donut.label}}</label>
            <label>{{donut.subLabel}}</label>
            <lib-dougnhut-chart [labelList]="donut.labelList" [dataList]="donut.dataList" [chartName]="'x'" [colors]="donut.colors"></lib-dougnhut-chart>
            <div class="buttons-section">
                <button id="info" [tooltip]="(donut.descripcion)"><i class="fa-solid fa-info"></i></button>
                <button class="grid" [ngClass]="{'disabled': !cargaCompleta}" (click)="showGrid(donut)" [tooltip]="('central-avisos.mostrarTabla' | translate)"><i class="fas fa-table"></i></button>
            </div>
        </div>
    </div>
</section>
<section class="flex-container" *ngIf="showAll && donutsDesignacionesInput">
    <div *ngFor="let donut of allDonuts">
        <div *ngIf="donut !== undefined" class="donut" [ngClass]="animation ? 'all' : ''">
            <label>{{donut.label}}</label>
            <label>{{donut.subLabel}}</label>
            <lib-dougnhut-chart [labelList]="donut.labelList" [dataList]="donut.dataList" [chartName]="'x'" [colors]="donut.colors"></lib-dougnhut-chart>
            <div class="buttons-section">
                <button id="info" [tooltip]="(donut.descripcion)"><i class="fa-solid fa-info"></i></button>
                <button class="grid" [ngClass]="{'disabled': !cargaCompleta}" (click)="showGrid(donut)" [tooltip]="('central-avisos.mostrarTabla' | translate)"><i class="fas fa-table"></i></button>
            </div>
        </div>
    </div>
</section>
<div class="modal" *ngIf="gridModal">
    <div class="modal-content">
        <header>
            <h4>{{tituloGrid}}</h4>
            <i class="fas fa-times" (click)="gridModal = !gridModal"></i>
          </header>
        <app-grid-avisos-designaciones [titulo]="tituloGrid" [dataExpedicionCero]="dataExpedicionCero" (refresh)="refresh($event)" (emitDataExpedicionCero)="getDataExpedicionCero($event)"></app-grid-avisos-designaciones>
    </div>
</div>
